import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import PickerLocale from "@bedrock/date-picker/es/locale/zh_CN";

function getDefaultFormat(format, picker, showTime, use12Hours) {
  var mergedFormat = format;

  if (!mergedFormat) {
    switch (picker) {
      case 'time':
        mergedFormat = use12Hours ? 'hh:mm:ss a' : 'HH:mm:ss';
        break;

      case 'week':
        mergedFormat = 'YYYY年-w周';
        break;

      case 'month':
        mergedFormat = 'YYYY-MM';
        break;

      case 'quarter':
        mergedFormat = 'YYYY-[Q]Q';
        break;

      case 'year':
        mergedFormat = 'YYYY';
        break;

      default:
        mergedFormat = showTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
    }
  }

  return mergedFormat;
}

var messages = _objectSpread(_objectSpread({}, PickerLocale), {}, {
  timeSelectPlaceholder: '请选择时间',
  dateSelectPlaceholder: '请选择日期',
  monthSelectPlaceholder: '请选择月份',
  quarterSelectPlaceholder: '请选择季度',
  yearSelectPlaceholder: '请选择年份',
  rangeTimeSelectPlaceholder: ['开始时间', '结束时间'],
  rangeDateSelectPlaceholder: ['开始日期', '结束日期'],
  rangeMonthSelectPlaceholder: ['开始月份', '结束月份'],
  rangeQuarterSelectPlaceholder: ['开始季度', '结束季度'],
  rangeYearSelectPlaceholder: ['开始年份', '结束年份'],
  monthFormat: 'M月',
  shortWeekDays: ['日', '一', '二', '三', '四', '五', '六'],
  weekFormat: 'YYYY年/w周',
  getDefaultFormat: getDefaultFormat
});

export default messages;